import React, { useState,useEffect } from "react";
import axios from "axios";
import { API_URL,RESPONSE_SUCCESS,REQUEST_NOT_FOUND } from './../../GlobalConstents.js';
import { Link, useNavigate } from "react-router-dom";
import HeaderLayout from "./../../Layout/Header";
import API from './../../Api';
import { toast } from 'react-toastify';
import Loader from "../../Elements/Loader";
import { ROUTE_VIDEO_INFO_PAGE,RouteChanged } from '../../RouteConstents';

const QuizList = () => {

    const navigate = useNavigate();

    const [records, setRecords] = useState([]); 
    const [isLoading, setIsLoading] = useState(false);
    const [videoURL, setVideoURL] = useState('');

    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');

        LoadQuizList()
        
    },[true]); 

    const LoadQuizList = async (request) => {

        let objValue =  {"method_name":"videoList","page":1,"course_id":2,"subject_id":2}

        setIsLoading(true);
        await API.post(API_URL,objValue).then(function (response) {
            setIsLoading(false);
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status == "success") {
                    setRecords(response.data.videoList);
                    setVideoURL(response.data.video_url); 
                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }
    
    return (
        <>
        <HeaderLayout />
        
        <section className="content">
            <div className="container-fluid">
                <div className="block-header">
                    <h2>Quizess</h2>
                </div> 

                <div className="row clearfix">

                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div className="card">
                            <div className="header bg-cyan">
                                <h2>Rajasthan Patwari 2023 - Test Series 1</h2>
                            </div>
                            <div className="body">
                                <p>
                                    <span className="label bg-purple mr-5">150 Questions</span> 
                                    <span className="label bg-blue mr-5">300 Marks</span>
                                    <span className="label bg-teal mr-5">120 Minutes</span>
                                </p>
                                
                                <p>
                                    <span className="label bg-indigo mr-5">Hindi</span>
                                    <span className="label bg-deep-orange mr-5">English</span>
                                </p>
                            </div>
                            <div className="btn btn-block btn-lg btn-success">
                                <button type="button" className="btn btn-default waves-effect">Start Now</button>
                            </div>
                        </div>
                    </div> 

                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div className="card">
                            <div className="header bg-cyan">
                                <h2>Rajasthan Patwari 2023 - Test Series 2</h2>
                            </div>
                            <div className="body">
                                <p>
                                    <span className="label bg-purple mr-5">150 Questions</span> 
                                    <span className="label bg-blue mr-5">300 Marks</span>
                                    <span className="label bg-teal mr-5">120 Minutes</span>
                                </p>
                                <p>
                                    <span className="label bg-indigo mr-5">Hindi</span>
                                    <span className="label bg-deep-orange mr-5">English</span>
                                </p>
                            </div>
                            <div className="btn btn-block btn-lg btn-success">
                                <button type="button" className="btn btn-default waves-effect">Start Now</button>
                            </div>
                        </div>
                    </div> 



                {
                    records.length > 0 ? (
                    records.map((item, index) => (

                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                        <div className="card">
                            <div className="header">
                                <h2>
                                    {item.video_title}
                                </h2>
                            </div>
                            <div className="body text-center">
                                <Link to={RouteChanged(ROUTE_VIDEO_INFO_PAGE,item.id)}>
                                    <img src={videoURL+item.thumbnail_image} className="img-responsive" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    ))
                    ) : (
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 text-center">
                            {isLoading ? (
                                <Loader />
                            ) : (
                                'Record Not Found'
                            )}
                        </div>
                    )    
                }
                </div>
            </div>
        </section>
        </>
    );
   
}
    
export default QuizList;